import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

const routes: Routes = [

  {
    path: 'login', 
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'dashboard', 
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'survey', 
    loadChildren: () => import('./pages/survey/answer/survey.module').then(m => m.SurveyPageModule),
  },
  {
    // Impostare 404?
    path: '**',
    runGuardsAndResolvers: 'always',
    redirectTo: '/dashboard',
    data: {
      title: 'Survey App'
    }
  }
];


@NgModule({
  //imports: [RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: PreloadAllModules })],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
